import { Box, Button } from "@mui/material";
import ProviderRolesAndResponsibility from "../../../../components/app/settings/ProviderRolesAndResponsibility";
import UpsertRoleModal from "../../../../components/app/settings/user-settings/UpsertRoleModal";
import Flex from "../../../../components/Flex";
import LabeledSwitch from "../../../../components/LabeledSwitch";
import Text from "../../../../components/Text";
import AddIcon from "@mui/icons-material/Add";
import useDisclosure from "../../../../hooks/use-disclosure";
import { useState } from "react";

const RolesAndResponsibilities = () => {
  // const { data } = UseRolesAndResList({});
  // const { data: a } = UserPreList({});

  const {
    opened: openedViewRoleModel,
    open: openViewRoleModel,
    close: closeViewRoleModel,
  } = useDisclosure(false);
  // const { mutateAsync: addRole } = useAddRole();

  const [isArchieved, setIsArcheived] = useState(false);

  return (
    <>
      <Flex
        justifyContent={"space-between"}
        alignItems={"center"}
        marginBottom={"10px"}
      >
        <Text fontWeight={"medium"} fontSize={20}>
          Roles and Permissions
        </Text>

        <UpsertRoleModal
          action={"add"}
          opened={openedViewRoleModel}
          onClose={closeViewRoleModel}
          onSave={() => new Promise(() => {})}
        />

        <Flex gap={2} alignItems={"center"}>
          <Box width={"100%"} display={"flex"} gap={1}>
            <LabeledSwitch
              label="Show Archived Roles"
              checked={isArchieved}
              onChange={(e) => setIsArcheived(e.target.checked)}
            />

            <Button
              size="large"
              variant="contained"
              startIcon={<AddIcon fontSize="small" />}
              onClick={openViewRoleModel}
            >
              Add New Role
            </Button>
          </Box>
        </Flex>
      </Flex>
      <ProviderRolesAndResponsibility archived={isArchieved} />
    </>
  );
};

export default RolesAndResponsibilities;
